import React from 'react'
import ButtonStartIcon from '../button/ButtonStartIcon'
import Dialog from './Dialog'

const DialogConfirmCancel = ({
  id,
  open,
  loading = false,
  onCancel,
  textCancel = 'Cancel',
  disabledCancel = false,
  onConfirm,
  textConfirm = 'Confirm',
  disabledConfirm = false,
  title,
  maxWidth = 'sm',
  onCloseHeader,
  children,
  showActions = true,
  ...rest
}) => {
  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onCancel}
        color='primary'
        variant='outlined'
        disabled={loading || disabledCancel}
        startIcon={['fal', 'times']}
      >
        {textCancel}
      </ButtonStartIcon>
      {onConfirm && (
        <ButtonStartIcon
          onClick={onConfirm}
          color='primary'
          variant='contained'
          disabled={loading || disabledConfirm}
          loading={loading}
          startIcon={['fal', 'check']}
        >
          {textConfirm}
        </ButtonStartIcon>
      )}
    </>
  )

  return (
    <Dialog
      id={`confirm-cancel-${id?.split(' ')?.join('-')}`}
      show={open}
      onClose={onCancel}
      title={title}
      maxWidth={maxWidth}
      actions={showActions ? Actions : null}
      onCloseHeader={onCloseHeader}
      {...rest}
    >
      {children}
    </Dialog>
  )
}

export default DialogConfirmCancel
